import React, { useContext, useMemo } from 'react';
import { CustomersContext, ICustomersContext } from '../../customersState/customersContext';
import { entityStatuses } from 'appConstants';
import { useTranslation } from 'react-i18next';
import { OutsideFormSelectNew } from 'components/Select/OutsideFormSelectNew';

export const StatusSelect: React.FC = () => {
	const { setStatus, status } = useContext<ICustomersContext>(CustomersContext);
	const { t } = useTranslation('listing');

	const options = useMemo(
		() =>
			entityStatuses.map((entityStatus) => ({
				id: entityStatus.id,
				name: t(entityStatus.name),
			})),
		[t],
	);

	return (
		<OutsideFormSelectNew
			testId="StatusSelect"
			name="StatusSelect"
			label="statusLabel"
			onChange={setStatus}
			value={status}
			options={options}
			listItemHeight={options.length}
			withSearch={false}
			allowClear={false}
			withValidation={false}
			withEmptyOption={false}
		/>
	);
};
